import Collection from "./Collection";


export default class Directus {
    $endpoint = ''

    constructor(endpoint, collections) {
        this.$endpoint = endpoint.endsWith('/') ? endpoint.substring(-1) : endpoint
        for (let collectionName in collections) {
            this[collectionName] = new Collection(this, collectionName, collections[collectionName])
        }
    }


    install(Vue, options) {
        Vue.$directus = new Directus(options.endpoint, options.collections)
    }
}
